import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogCardMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondRightSectVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSecFirstCard.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSecSecondCard.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSectBottmVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSectionRightMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSecondSectTopVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogSectionSectionBottomVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogTopMobileVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/blogtoprightVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/backgroundVectors/leftBlogVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blogImages/blogHeroImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blogImages/blogMobileHeroImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blogImages/blueCardBottomVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blogImages/blueCardTopVector.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/blogImages/eventCardImage.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Food.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/Icons/pilResurs13303.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/manInCoat.jpg");
